import { apiPost, apiGet } from '../../utils/api';
import React, { useState } from 'react';
import { BarChart3, Play, Clock } from 'lucide-react';
import { toast } from 'react-hot-toast';

const BenchmarkBuilder = () => {
  const [code, setCode] = useState('');
  const [iterations, setIterations] = useState(1000);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleRunBenchmark = async () => {
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/development/benchmark-builder', { code, iterations });
      setResult(data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-6 mt-6">
      <div className="flex items-center gap-2 mb-4">
        <BarChart3 className="w-6 h-6 text-gray-700" />
        <h1 className="text-2xl font-bold text-gray-900">Construtor de Benchmark</h1>
      </div>
      <p className="text-gray-700 mb-4">Teste a performance do seu código JavaScript. Execute benchmarks personalizados e compare diferentes implementações.</p>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-2">
            Código JavaScript
          </label>
          <textarea
            className="w-full h-64 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none font-mono text-sm bg-gray-50"
            placeholder="// Digite seu código aqui...&#10;for (let i = 0; i < 1000; i++) {&#10;  // seu código&#10;}"
            value={code}
            onChange={e => setCode(e.target.value)}
          />
        </div>
        
        <div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Iterações: {iterations}
            </label>
            <input
              type="range"
              min="100"
              max="10000"
              step="100"
              value={iterations}
              onChange={e => setIterations(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
          </div>
          
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded transition mb-4 flex items-center gap-2 disabled:opacity-60 w-full"
            onClick={handleRunBenchmark}
            disabled={!code.trim() || loading}
          >
            {loading && <span className="loader border-white" />}
            <Play className="w-4 h-4" />
            Executar Benchmark
          </button>
          
          {result && (
            <div className="bg-gray-50 border rounded-lg p-4">
              <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <Clock className="w-4 h-4" />
                Resultados do Benchmark
              </h3>
              <div className="space-y-2 text-sm">
                <p><strong>Tempo Total:</strong> {result.totalTime}ms</p>
                <p><strong>Tempo Médio:</strong> {result.averageTime}ms</p>
                <p><strong>Iterações:</strong> {result.iterations}</p>
                <p><strong>Operações/segundo:</strong> {result.opsPerSecond}</p>
                {result.memory && <p><strong>Uso de Memória:</strong> {result.memory}MB</p>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BenchmarkBuilder; 